import { useCallback } from 'react'
import ApiService from 'services/ApiService'
import { getMessage } from 'utility/MapperResponse'
import { getTranslate } from 'utility/MapperTranslate'
import { confirmationAlert, showAlert } from 'utility/SweetAlert'

const InteractorMasterPostalCodeCreate = () => {
  const postalCodeCreate = useCallback((body, loading) => {
    confirmationAlert({
      message: getTranslate('message.confirm_process'),
      icon: 'question',
    }).then((result) => {
      if (result === true) {
        ApiService.jsonRequest('/management/master-postal-code/create', body, (response) => {
          loading(false)
          if (response.code === 7201) {
            showAlert({
              icon: 'success',
              message: getTranslate('message.successfully_created'),
              timer: 2000,
              redirect: '/administrator/master/postal-code/manage',
            })
          } else {
            showAlert({
              icon: 'error',
              message: getMessage(response?.msg),
              timer: 2000,
            })
          }
        })
      } else {
        loading(false)
      }
    })
  }, [])
  return { postalCodeCreate }
}

export default InteractorMasterPostalCodeCreate
